<div class="mass-os-gen-page">
  <app-file-programming-header
    [eyebrow]="'Operaciones'"
    [title]="mode === 'os' ? 'Generación de Órdenes de Servicio Masivas' : 'Generación de Notas de Pedido Masivas'"
    [subtitle]="
      mode === 'os'
        ? 'Genera órdenes de servicio por proveedor y periodo en tres pasos.'
        : 'Genera notas de pedido por proveedor y periodo en tres pasos.'
    "
    [icon]="'receipt_long'"
    [isLoading]="false"
    [resultCount]="itineraries.length"
    [activeFilterCount]="activeFilterCount"
    (refresh)="onRefresh()"
  ></app-file-programming-header>

  <app-mass-os-stepper
    [steps]="steps"
    [activeIndex]="activeStep"
    (stepSelect)="onStepSelected($event)"
  ></app-mass-os-stepper>

  <ng-container *ngIf="activeStep === 0">
    <div
      *ngIf="stepOneError"
      class="mass-os-gen-info mass-os-gen-info--error"
      role="alert"
    >
      <mat-icon>error_outline</mat-icon>
      <span>{{ stepOneError }}</span>
    </div>

    <div class="mass-os-gen-info mass-os-gen-info--filters">
      <mat-icon>info</mat-icon>
      <span>
        Selecciona el Proveedor, Periodo y Servicios para ver los files
        disponibles.
      </span>
    </div>

    <div class="mass-os-gen-step mass-os-gen-step--filters">
      <app-mass-os-provider-period
        [providers]="providers"
        [providerId]="form.providerId"
        [periodMode]="form.periodMode"
        [year]="form.year"
        [months]="form.months"
        [rangeStart]="form.rangeStart"
        [rangeEnd]="form.rangeEnd"
        [submitted]="stepOneSubmitted"
        [isLoadingProviders]="isLoadingProviders"
        (formChange)="onStepOneChange($event)"
      ></app-mass-os-provider-period>

      <app-mass-os-client
        [b2bClientIds]="form.b2bClientIds"
        [b2bClients]="b2bClients"
        [submitted]="stepOneSubmitted"
        [isLoadingClients]="isLoadingClients"
        (formChange)="onStepOneChange($event)"
      ></app-mass-os-client>

      <app-mass-os-service-types
        [serviceTypeIds]="form.serviceTypeIds"
        [submitted]="stepOneSubmitted"
        (formChange)="onStepOneChange($event)"
      ></app-mass-os-service-types>
    </div>

    <div class="mass-os-gen-actions mass-os-step1-actions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="mass-os-gen-actions__continue"
        [disabled]="isLoadingItineraries"
        (click)="continueToNextStep()"
      >
        <mat-progress-spinner
          *ngIf="isLoadingItineraries"
          class="mass-os-gen-actions__spinner"
          diameter="18"
          mode="indeterminate"
        ></mat-progress-spinner>
        <ng-container *ngIf="!isLoadingItineraries">Continuar</ng-container>
        <ng-container *ngIf="isLoadingItineraries"
          >Cargando files...</ng-container
        >
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="activeStep === 1">
    <app-mass-os-review-summary
      [mode]="mode"
      [form]="form"
      [providers]="providers"
      [selectedServiceCount]="selectedServiceCount"
      [selectedTicketCount]="selectedTicketCount"
      (back)="onStepSelected(0)"
      (syncPaymentDate)="onSyncPaymentDate()"
    ></app-mass-os-review-summary>

    <div class="mass-os-applied" *ngIf="appliedFilterChips.length">
      <div class="mass-os-applied__header">
        <div class="mass-os-applied__title">
          <mat-icon class="mass-os-applied__title-icon">tune</mat-icon>
          <span>Filtros aplicados</span>
          <span class="mass-os-applied__count">{{
            appliedFilterChips.length
          }}</span>
        </div>
      </div>
      <div class="mass-os-applied__chips">
        <span
          class="mass-os-applied__chip"
          *ngFor="let chip of appliedFilterChips; trackBy: trackFilterChip"
        >
          <span class="mass-os-applied__chip-text">{{ chip.label }}</span>
        </span>
      </div>
    </div>

    <app-mass-os-itineraries-table
      #itinerariesTable
      class="mass-os-gen-itineraries"
      [itineraries]="itineraries"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [paginatorLength]="paginatorLength"
      [isLoading]="isLoadingItineraries"
      (pageChange)="onTablePageChange($event)"
      (selectionChanged)="selectedServiceCount = $event"
      (ticketSelectionChanged)="selectedTicketCount = $event"
    ></app-mass-os-itineraries-table>
  </ng-container>

  <div class="mass-os-gen-step mass-os-gen-step--summary" *ngIf="activeStep === 2">
    <div class="mass-os-gen-info mass-os-gen-info--success">
      <mat-icon>check_circle</mat-icon>
      <span>
        Revisa la distribución de las
        {{ mode === 'os' ? 'Órdenes de Servicio' : 'Notas de Pedido' }} por file,
        fecha de pago y moneda. Cada grupo representa una
        {{ mode === 'os' ? 'OS' : 'NP' }}.
      </span>
    </div>

    <div class="mass-os-gen-summary">
      <div class="mass-os-gen-summary__scroll" *ngIf="fileOsGroups.length; else emptyOs">
        <div
          *ngFor="let fileGroup of fileOsGroups; let fi = index"
          class="mass-os-gen-summary__file"
        >
          <div class="mass-os-gen-summary__file-header">
            <mat-icon>folder</mat-icon>
            <span class="mass-os-gen-summary__file-name">
              File: {{ fileGroup.fileNumber }}
            </span>
            <span class="mass-os-gen-summary__file-count">
              {{ fileGroup.fechaGrupos.length }} fecha(s) de pago
            </span>
          </div>

          <div
            *ngFor="let fechaGroup of fileGroup.fechaGrupos; let di = index"
            class="mass-os-gen-summary__fecha"
          >
            <div class="mass-os-gen-summary__fecha-header">
              <mat-icon>event</mat-icon>
              <span>Pago programado: {{ formatShortDate(fechaGroup.fechaPago) }}</span>
              <span class="mass-os-gen-summary__fecha-count">
                {{ fechaOsCount(fechaGroup) }} {{ mode === 'os' ? 'OS' : 'NP' }}
              </span>
            </div>

            <div *ngFor="let monedaGroup of fechaGroup.monedaGrupos; let mi = index" class="mass-os-gen-summary__moneda">
              <div class="mass-os-gen-summary__moneda-header">
                <mat-icon>payments</mat-icon>
                <span>Moneda: {{ monedaGroup.moneda }}</span>
                <span class="mass-os-gen-summary__moneda-count">
                  {{ monedaGroup.codigoGrupos.length }} {{ mode === 'os' ? 'OS' : 'NP' }}
                </span>
              </div>

              <div
                *ngFor="let group of monedaGroup.codigoGrupos; let ci = index"
                class="mass-os-gen-summary__os-card"
              >
              <div class="mass-os-gen-summary__os-card-header">
                <span
                  class="mass-os-gen-summary__os-card-badge"
                  [class.mass-os-gen-summary__os-card-badge--pending]="mode === 'os' ? !group.numOS : !group.purchaseNoteId"
                >
                  <ng-container *ngIf="mode === 'os'">
                    <ng-container *ngIf="group.numOS; else pendingBadge">
                      OS {{ group.numOS }}
                    </ng-container>
                    <ng-template #pendingBadge>OS por generar</ng-template>
                  </ng-container>
                  <ng-container *ngIf="mode === 'np'">
                    <ng-container *ngIf="group.purchaseNoteNumber; else pendingBadge">
                      NP {{ group.purchaseNoteNumber }}
                    </ng-container>
                    <ng-template #pendingBadge>NP por generar</ng-template>
                  </ng-container>
                </span>
                <span class="mass-os-gen-summary__os-card-moneda">{{ group.moneda }}</span>
                <span class="mass-os-gen-summary__os-card-sep">·</span>
                <span class="mass-os-gen-summary__os-card-count">
                  {{ group.units.length }} ítem(s)
                </span>
                <span class="mass-os-gen-summary__os-card-sep">·</span>
                <span class="mass-os-gen-summary__os-card-total">
                  Total: {{ group.moneda }}
                  {{ (group.payableTotal ?? group.total) | formatNumber }}
                </span>
                <button
                  *ngIf="mode === 'os' ? group.numOS : group.purchaseNoteId"
                  type="button"
                  class="mass-os-gen-summary__os-card-pdf"
                  [title]="mode === 'os' ? 'Ver PDF de la OS' : 'Ver PDF de la NP'"
                  (click)="verPdf(group)"
                >
                  <mat-icon>picture_as_pdf</mat-icon>
                  <span>Ver PDF</span>
                </button>
              </div>
              <div
                class="mass-os-gen-summary__os-pay"
                *ngIf="group.commissionAmount != null"
              >
                <span>Monto {{ group.moneda }} {{ group.total | formatNumber }}</span>
                <span>{{ group.commissionLabel }} {{ group.moneda }} {{ group.commissionAmount | formatNumber }}</span>
                <strong>Total: {{ group.moneda }} {{ group.payableTotal | formatNumber }}</strong>
              </div>
              <div class="mass-os-gen-summary__os-card-meta">
                <div
                  *ngIf="mode === 'os'"
                  class="mass-os-gen-summary__os-card-meta-item mass-os-gen-summary__os-card-meta-item--code"
                >
                  <mat-icon>vpn_key</mat-icon>
                  <span class="mass-os-gen-summary__os-card-meta-label">Código de reserva</span>
                  <strong>{{ group.codigoReserva || '—' }}</strong>
                </div>
                <div
                  class="mass-os-gen-summary__os-card-meta-item mass-os-gen-summary__os-card-meta-item--obs"
                >
                  <mat-icon>notes</mat-icon>
                  <span class="mass-os-gen-summary__os-card-meta-label">Observaciones</span>
                  <strong>{{ group.observaciones || '—' }}</strong>
                </div>
              </div>
              <div class="mass-os-gen-summary__os-card-body">
                <div
                  class="mass-os-gen-summary__os-grid mass-os-gen-summary__os-grid--head"
                  [class.mass-os-gen-summary__os-grid--pay]="mode === 'os' && group.commissionAmount != null"
                >
                  <span>Día</span>
                  <span>Servicio</span>
                  <span>Proveedor</span>
                  <span>Fecha</span>
                  <span>Monto</span>
                  <span *ngIf="mode === 'os' && group.commissionAmount != null">Comisión</span>
                  <span *ngIf="mode === 'os' && group.commissionAmount != null">Total</span>
                </div>
                <ng-container *ngFor="let unit of group.units; let unitIndex = index">
                  <div
                    class="mass-os-gen-summary__os-grid"
                    [class.mass-os-gen-summary__os-grid--ticket]="unit.kind === 'ticket'"
                    [class.mass-os-gen-summary__os-grid--pay]="mode === 'os' && group.commissionAmount != null"
                  >
                    <span class="mass-os-gen-summary__os-svc-day"
                      ><ng-container *ngIf="unit.kind === 'ticket'"
                        ><mat-icon class="mass-os-gen-summary__ticket-dot">confirmation_number</mat-icon
                      ></ng-container
                      >{{ unit.serviceDay }}</span
                    >
                    <span class="mass-os-gen-summary__os-svc-name">
                      {{ unit.nombreServicio
                      }}<span *ngIf="unit.kind === 'ticket'" class="mass-os-gen-summary__ticket-id">
                        • Ticket {{ unit.ticketId }}</span
                      >
                    </span>
                    <span class="mass-os-gen-summary__os-svc-provider"
                      >{{ unit.nombre }}</span
                    >
                    <span class="mass-os-gen-summary__os-svc-date"
                      >{{ formatShortDate(unit.fecha) }}</span
                    >
                    <span class="mass-os-gen-summary__os-svc-cost"
                      >{{ unit.moneda }} {{ unit.total | formatNumber }}</span
                    >
                    <ng-container *ngIf="mode === 'os' && group.commissionAmount != null">
                      <span class="mass-os-gen-summary__os-svc-cost"
                        >{{ unit.moneda }}
                        {{ (unitPay(unit, group, unitIndex)?.commission || 0) | formatNumber }}</span
                      >
                      <span class="mass-os-gen-summary__os-svc-cost"
                        >{{ unit.moneda }}
                        {{ (unitPay(unit, group, unitIndex)?.total || unit.total) | formatNumber }}</span
                      >
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <ng-template #emptyOs>
        <div class="mass-os-gen-summary__empty">
          <mat-icon>inbox</mat-icon>
          <span>Selecciona servicios para generar las {{ mode === 'os' ? 'órdenes' : 'notas de pedido' }}.</span>
        </div>
      </ng-template>
    </div>

    <div class="mass-os-gen-summary__footer">
      <div class="mass-os-gen-summary__stats">
        <div class="mass-os-gen-stat">
          <span class="mass-os-gen-stat__value">{{ totalServices }}</span>
          <span class="mass-os-gen-stat__label">Servicios</span>
        </div>
        <div class="mass-os-gen-stat">
          <span class="mass-os-gen-stat__value">{{ totalOs }}</span>
          <span class="mass-os-gen-stat__label">Órdenes</span>
        </div>
        <div
          *ngFor="let ct of currencyTotals"
          class="mass-os-gen-stat mass-os-gen-stat--accent"
        >
          <span class="mass-os-gen-stat__value">
            {{ ct.moneda }} {{ ct.total | formatNumber }}
          </span>
          <span class="mass-os-gen-stat__label">Total</span>
        </div>
      </div>

      <div class="mass-os-gen-summary__actions">
        <button
          mat-stroked-button
          type="button"
          class="mass-os-gen-summary__back"
          (click)="onStepSelected(0)"
        >
          <mat-icon>arrow_back</mat-icon>
          Volver a Revisar
        </button>
      </div>
    </div>
  </div>
</div>
